module.exports = __webpack_public_path__ + "static/img/attack_spanish.cff7793.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/attack_spanish.png
// module id = i6HW
// module chunks = 94